<template>
<el-row class="text-align-left" >
  <div id="full-background" v-if="showBackground"></div>
  <el-col :xl="16" :lg="16" :md="19" :sm="19">
    <el-row>
      <img src="../assets/OOCL_logo.svg" class="oocl-logo">
    </el-row>
    <el-row>
      <el-col :span="5" style="height:10px"></el-col>
      <el-col :span="19">
        <div class="welcome">
          <div class="welcome-title" v-if="answererDto.userType === userVendor">OOCL's {{answererDto.userType}} <br>ESG Assessment</div>
          <div class="welcome-title" v-else>OOCL {{answererDto.userType}} <br>Engagement Survey</div>
          <div class="welcome-line"></div>
          <p class="welcome-message">{{answererVO.answererName}},</p>
          <div>{{selectEn}}</div>
          <div>{{selectSc}}</div>
          <div>{{selectTc}}</div>
          <div style="height: 150px;">
            <el-button type="danger" @click="enAnswer">{{buttonEn}}</el-button>
            <el-button type="danger" @click="scAnswer">{{buttonSc}}</el-button>
            <el-button type="danger" @click="tcAnswer">{{buttonTc}}</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-col>
  <el-col :xl="8" :lg="8" :md="5" :sm="5" class="welcome-image">
  </el-col>
  <el-col id="cookie-policy" :span="24" class="cookie-policy" v-if="showCookiePolicy">
    <div style="width: 100%;text-align: right;padding-right: 20px;margin-top: -22px;" v-if="showBackground">
      <span class="csck-modal-glide" @click="CloseCookieModal" data-dismiss="modal">
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="ICON" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <rect id="Rectangle-2-Copy" fill="#28469C" x="2" y="17" width="20" height="2"></rect>
            <polyline id="Path-3" stroke="#28469C" stroke-width="2" points="5 5 12 12 19 5"></polyline>
          </g>
        </svg>
       </span>
    </div>
    <el-col :xl="2" :lg="2" :md="1" :sm="1" style="height:1px"></el-col>
    <el-col :xl="16" :lg="15" :md="22" :sm="22" class="container padding">
      <div class="cookie-msg">
        <u>Cookies Notice</u><br><br>
        We use cookies as a fundamental part of our interaction with our users’ browsers.<br/><br/>
        We rely on your consent for placing on your browser cookies which may collect personal data about you. You can provide your consent by clicking “Accept”. You are free at any time to block or delete cookies through your browser.
      </div>
    </el-col>
    <el-col :xl="4" :lg="5" :md="22" :sm="22" class="text-center">
      <el-button type="danger" @click="acceptCookiePolicy">Accept</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
      <el-button type="default" @click="goKnowMore">Read More</el-button>
    </el-col>
    <el-col :xl="2" :lg="2" :md="1" :sm="1" style="height:10px"></el-col>
  </el-col>
  <Footer v-on:init="init"></Footer>
</el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import { checkAnswerInfo } from '@/services/answerer/answerer.service'
import { EMIT_SAVE_ANSWERERINFO } from '@/store/types'
import Constant from '@/common/Constant'
import CookiesHelper from '@/utils/cookiesHelper'

export default {
  data () {
    return {
      selectEn: '',
      selectSc: '',
      selectTc: '',
      buttonEn: '',
      buttonSc: '',
      buttonTc: '',
      showCookiePolicy: false,
      showBackground: false,
      answererDto: {
        userType: '',
        answerAssessmentId: '',
        keyCode: ''
      },
      answererVO: {
        answererName: '',
        status: '',
        openDate: '',
        closeDate: '',
        accessSucceed: false,
        assessmentId: ''
      },
      userVendor: Constant.TYPE_VENDOR
    };
  },
  components: {
    Footer
  },
  methods: {
    enAnswer () {
      sessionStorage.setItem(Constant.LANGUAGE, Constant.LANGUAGE_EN);
      if (this.showCookiePolicy === true) {
        this.moveCookiePolicy();
      } else {
        this.$router.push({name: 'CoverPage'});
      }
    },
    scAnswer () {
      sessionStorage.setItem(Constant.LANGUAGE, Constant.LANGUAGE_SC);
      if (this.showCookiePolicy === true) {
        this.moveCookiePolicy();
      } else {
        this.$router.push({name: 'CoverPage'});
      }
    },
    tcAnswer () {
      sessionStorage.setItem(Constant.LANGUAGE, Constant.LANGUAGE_TC);
      if (this.showCookiePolicy === true) {
        this.moveCookiePolicy();
      } else {
        this.$router.push({name: 'CoverPage'});
      }
    },
    init () {
      this.selectEn = this.$store.state.dictionary[1].LABEL_SELECTLANGUAGE;
      this.selectSc = this.$store.state.dictionary[2].LABEL_SELECTLANGUAGE;
      this.selectTc = this.$store.state.dictionary[3].LABEL_SELECTLANGUAGE;
      this.buttonEn = this.$store.state.dictionary[1].BUTTON_LANGUAGE;
      this.buttonSc = this.$store.state.dictionary[2].BUTTON_LANGUAGE;
      this.buttonTc = this.$store.state.dictionary[3].BUTTON_LANGUAGE;
    },
    async checkAnswerInfo (params) {
      const answererInfo = await checkAnswerInfo(params);
      this.answererVO = answererInfo.data;
      // accessSucceed.accessSucceed
      switch (this.answererVO.accessSucceed) {
        case Constant.ACCESSSUCCEED_TYPE_ACCESSDENIED:
          this.goAccessDenied();
          break;
        case Constant.ACCESSSUCCEED_TYPE_CLOSE:
          this.goClose();
          break;
      }
      this.$store.dispatch(EMIT_SAVE_ANSWERERINFO, this.answererVO); // save user-info in store then others can call it
      sessionStorage.setItem(Constant.USER_TYPE, this.answererDto.userType);
      sessionStorage.setItem(Constant.ANSWER_ASSESSMENT_ID, this.answererDto.answerAssessmentId);
      sessionStorage.setItem(Constant.USER_NAME, this.answererVO.answererName);
      sessionStorage.setItem(Constant.ASSESSMENT_ID, this.answererVO.assessmentId);
      sessionStorage.setItem(Constant.ASSESSMENT_KEY_CODE, this.answererDto.keyCode);
      if (answererInfo.data.status === Constant.ANSWER_STATUS_COMPLETED) { // no need show assessment if completed
        this.goCompleted();
      }
    },
    // this.answererVO.answererName = answererInfo.data.answererName;
    getUrlPara () {
      let url = document.location.toString();
      let arrUrl = url.split('//')[1];
      let params = arrUrl.split('/');
      if (params[1] !== Constant.TYPE_VENDOR && params[1] !== Constant.TYPE_STAKEHOLDER) {
        this.goPageNotFound();
      }
      this.answererDto.userType = params[1];
      this.answererDto.answerAssessmentId = params[2];
      this.answererDto.keyCode = params[3];
    },
    goPageNotFound () {
      this.$router.push({name: 'Error404'});
    },
    goAccessDenied () {
      this.$router.push({name: 'AccessDenied'});
    },
    goCompleted () {
      this.$router.push({name: 'AssessmentCompleted', params: { userType: this.answererDto.userType, language: Constant.LANGUAGE_ALL }});
    },
    goClose () {
      this.$router.push({name: 'Close'});
    },
    moveCookiePolicy () {
      this.showBackground = true;
      let a = document.getElementById('cookie-policy');
      a.style.top = '50%';
    },
    CloseCookieModal () {
      this.showBackground = false;
      let a = document.getElementById('cookie-policy');
      a.style.removeProperty('top');
    },
    goKnowMore () {
      window.open(Constant.COOKIE_POLICY);
    },
    acceptCookiePolicy () {
      let Days = 30;
      let exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 3600 * 1000);
      document.cookie = 'AcceptCookie' + '=' + 'yes' + '; expires=' + exp.toGMTString() + '; path=/';
      this.showCookiePolicy = false;
      this.showBackground = false;
    },
    readCookie () {
      let isAccepted = CookiesHelper.get('AcceptCookie');
      this.showCookiePolicy = !(isAccepted !== null && isAccepted === 'yes');
    }
  },
  mounted () {
    this.getUrlPara(); // get params from URL
    this.readCookie();
    this.checkAnswerInfo(this.answererDto);
    // set title
    if (this.answererDto.userType === Constant.TYPE_VENDOR) {
      document.title = 'OOCL Vendor ESG Assessment';
    } else {
      document.title = 'OOCL Stakeholder Engagement Survey';
    }
  }
}
</script>

<style>
  html {
    height: 100%;
  }

  body {
    height: 100%;
  }
</style>
<style scoped>

  .text-align-left{
    text-align: left;
    height: 100%;
  }

  .oocl-logo{
    height: 50px;
    padding-top: 50px;
    padding-left: 48px;
  }

  .welcome{
    padding-top: 40px;
  }

  .welcome-wording{
    padding-top: 70px;
    font-size: 20px;
    font-weight: bold;
  }

  .welcome-wording-1{
    display: inline-block;
    color: #333333;
  }

  .welcome-wording-2{
    display: inline-block;
    padding-left: 6px;
    color: #d63246;
    position: relative;
    bottom: 2px;
  }

  .welcome-title{
    color: #d63246;
    font-size: 64px;
    font-weight: bold;
    padding-top: 47px;
  }

  .welcome-line{
    background-image: url("../assets/line.png");
    background-repeat: no-repeat;
    height: 10px;
    margin-top: 10px;
  }

  .welcome-message{
    font-size: 16px;
    color: #000000;
    padding-top: 70px;
  }

  .welcome .el-button{
    width: 180px;
    height: 48px;
    margin-top: 42px;
    margin-right: 50px;
    font-size: 16px;
  }
  .welcome-image{
    background-image: url("../assets/start.png");
    background-repeat: no-repeat;
    height: 100%;
    background-position: 50% 90%;
  }

  /*cookie */
  .cookie-policy {
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 19;
    background: #f3ffff;
    padding: 32px 0;
    color: #226c94;
    font-size: 16px;
    -webkit-box-shadow: 0 -2px 8px rgba(0,0,0,.25);
    -moz-box-shadow: 0 -2px 8px rgba(0,0,0,.25);
    box-shadow: 0 -2px 8px rgba(0,0,0,.25);
    height: 250px;
  }

  .cookie-msg{
    padding-bottom: 20px;
  }

  .cookie-policy .container {
    height: auto!important;
    min-height: 100px;
  }

  .text-center{
    text-align: center;
    padding-left: 20px;
  }

  .cookie-policy .padding{
    padding: 0 20px;
  }

  /* RWD Support */
  @media screen and (max-width: 1500px){
    .welcome-title{
      font-size: 48px;
    }
    .welcome .el-button{
      width: 135px;
      height: 36px;
      margin-right: 30px;
    }
  }

  @media screen and (max-width: 992px){
    .welcome-image{
      background-image: none;
    }
  }

  @media screen and (max-height: 900px){
    .welcome-wording{
      padding-top: 30px;
    }
  }

  @media screen and (max-height: 900px) and (max-width: 1024px){
    .welcome-image{
      background-image: none;
    }
  }

  /*rewrite element-ui style */
  >>>.el-button{
    border-color: #D63246;
    color: #D63246;
  }

  >>>.el-button:hover{
    border-color: #D63246;
    background-color: #f4dbdb;
    color: #D63246;
  }

  >>>.el-button:focus{
    border-color: #D63246;
    background-color: #f4dbdb;
    color: #D63246;
  }

  >>>.el-button--danger{
    background-color: #D63246;
    border-color: #D63246;
    color: #fff;
  }

  >>>.el-button--danger:hover{
    background-color: #bf2134;
    border-color: #bf2134;
    color: #fff;
  }

  >>>.el-button--danger:focus{
    background-color: #bf2134;
    border-color: #bf2134;
    color: #fff;
  }
  >>>#full-background {
    width: 100%;
    height: 100%;
    background-color: gray;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    z-index: 3;
    filter: alpha(opacity=50);
    -moz-opacity: 0.5;
    -khtml-opacity: 0.5;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Start.vue